import { openContactForm } from "../../Functions/contactFormFunctions";
import domesticImg3 from "../../Images/domesticImg3.jpg";
import "./style.scss";

const WelcomePage: React.FC = () => {
    return (
        <div className="welcome">
            <div className="backgroundImg">
                <img src={domesticImg3} alt="Farnham and District Window Cleaning" />
            </div>
            
            <div className="welcomeContent">
                <div className="heroContainer">
                    <p className="heroTagline">Established & Family Run Since 1972</p>
                    <h1 className="heroTitle">Farnham and District Window Cleaning</h1>
                    <p className="heroSubtitle">High-quality window and gutter cleaning services for residential and commercial properties. Contact us today for a free, no-obligation quote.</p>
                    
                    <div className="heroActions">
                        <button onClick={() => openContactForm()} className="ctaButton">
                            Get Your Free Quote
                            <span className="material-symbols-outlined">arrow_forward</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WelcomePage;
